import { Suspense } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Container, Content, Navbar } from './style';
import ErrorBoundary from '../ErrorBoundary';
import RouteLoading from '../RouteLoading';
import Logo from '../../assets/icons/logo.svg?react';

const AuthLayout = () => {
  return (
    <Container>
      <Navbar>
        <NavLink to="/">
          <Logo />
        </NavLink>
      </Navbar>
      <Content>
        <ErrorBoundary componentName="AuthRoute">
          <Suspense fallback={<RouteLoading />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </Content>
    </Container>
  );
};

export default AuthLayout;
